import {CashReceiptIssueType, CashReceiptIssueUsage, ReceiptAdditionalPolicy} from '@web/core/constants'
import makeSlice from '@web/slices/cashReceipt/sliceMaker'

import {initOrderSheetByAPI} from '../../actions/familyPay'

const slice = makeSlice({
    extraReducers(builder) {
        builder.addCase(initOrderSheetByAPI.fulfilled, (state, {payload: {data}}) => {
            const {
                purchaser: {cashReceipt, receiptIssue},
            } = data

            state.available = receiptIssue ?? true

            if (cashReceipt) {
                // 이전 발행기록이 있을경우 saved에 이전발행유형 저장
                state.issueType.saved = cashReceipt.issueNumber ? cashReceipt.usageType : null
                state.issueType.current = cashReceipt.issueType ?? CashReceiptIssueType.PR_CELL_PHONE_NUMBER

                state.receiptPolicy = [ReceiptAdditionalPolicy.NFC_PREPAID]

                state.isEdit = !cashReceipt.issueType
                // 제거된 주민번호 유형으로 내려올 경우 대응
                if (cashReceipt.issueType === CashReceiptIssueType.PR_SOCIAL_NUMBER) {
                    state.issueType.current = CashReceiptIssueType.PR_CELL_PHONE_NUMBER
                    state.isEdit = true
                    state.issueType.saved = null
                }
                // 이전발행유형이 개인일경우 최근선택한 하위유형에 저장
                if (cashReceipt.usageType === CashReceiptIssueUsage.PERSONAL_INCOME_TAX) {
                    state.issueType.prev = cashReceipt.issueType ?? CashReceiptIssueType.PR_CELL_PHONE_NUMBER
                }
                if (cashReceipt.issueType && cashReceipt.issueType !== CashReceiptIssueType.PR_SOCIAL_NUMBER) {
                    state.issueNumber[cashReceipt.issueType] = (function getIssueNumber() {
                        const issueNumberMap = {
                            [CashReceiptIssueType.PR_CELL_PHONE_NUMBER]: [
                                cashReceipt.mobilePhoneNumberFirst ?? '',
                                cashReceipt.mobilePhoneNumberSecond ?? '',
                                cashReceipt.mobilePhoneNumberThird ?? '',
                            ],
                            [CashReceiptIssueType.PR_CASH_RECEIPT_CARD_NUMBER]: [
                                cashReceipt.cashReceiptCardNumberFirst ?? '',
                                cashReceipt.cashReceiptCardNumberSecond ?? '',
                                cashReceipt.cashReceiptCardNumberThird ?? '',
                                cashReceipt.cashReceiptCardNumberFourth ?? '',
                            ],
                            [CashReceiptIssueType.BUSINESS_REGISTRATION_NUMBER]: [
                                cashReceipt.businessRegistrationNumberFirst ?? '',
                                cashReceipt.businessRegistrationNumberSecond ?? '',
                                cashReceipt.businessRegistrationNumberThird ?? '',
                            ],
                        }
                        return issueNumberMap[cashReceipt.issueType] ?? ['', '', '']
                    })()
                }
            }
        })
    },
})

export default slice.reducer
